const FETCH_SCORE = 'estadisticas/score/FETCH_SCORE';
const FETCH_SCORE_COMPLETED = 'estadisticas/score/FETCH_SCORE_COMPLETED';
const FETCH_SCORE_FAILED = 'estadisticas/score/FETCH_SCORE_FAILED';

export { FETCH_SCORE, FETCH_SCORE_COMPLETED, FETCH_SCORE_FAILED };
